import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoGridProps {
  videos: Video[];
}

export default function VideoGrid({ videos }: VideoGridProps) {
  if (videos.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-foreground-400">
        <i className="ri-film-line text-5xl mb-4"></i>
        <p className="text-lg">暂无相关影视资源</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
      {videos.map((video) => (
        <Link
          key={video.id}
          to={`/article/${video.id}`}
          className="group block"
        >
          <div className="relative aspect-video rounded-lg overflow-hidden bg-background-200 mb-2.5">
            <img
              src={video.thumbnail}
              alt={video.title}
              title={`${video.title} - 91在线视频`}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors"></div>
            <div className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-1.5 py-0.5 rounded">
              {video.duration}
            </div>
            <div className="absolute top-2 left-2">
              <span className="bg-primary-500 text-white text-xs px-1.5 py-0.5 rounded">
                {video.rating}
              </span>
            </div>
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
              <div className="w-10 h-10 bg-primary-500/90 rounded-full flex items-center justify-center">
                <i className="ri-play-fill text-white text-lg ml-0.5"></i>
              </div>
            </div>
          </div>
          <h3 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">
            {video.title}
          </h3>
          <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
            <span>{video.category}</span>
            <span>·</span>
            <span>{video.year}</span>
          </div>
        </Link>
      ))}
    </div>
  );
}